<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Add Users</h4>
</div>

<div class="modal-body" style="overflow: visible !important">
  From

  <p-dropdown
    [options]="dashboardStore.clients | activeClientsOnly"
    [(ngModel)]="selected"
    optionLabel="name"
    [filter]="true"
    filterBy="name"
    [showClear]="true"
    placeholder="Select a Workspace"
    (onChange)="valueChange($event)"
  >
    <ng-template let-client pTemplate="item">
      <div class="flex align-items-center gap-2">
        <div>{{ client.name }}</div>
      </div>
    </ng-template>
  </p-dropdown>

  Workspace

  <div class="row" style="margin-top: 30px">
    <div
      class="col-md-4"
      *ngFor="let u of availableUsers"
      (click)="toggleUserInvite(u)"
    >
      <div class="user-invite" [ngClass]="{ selected: u.selected }">
        <div class="user-avatar">
          <div class="avatar avatar-48">
            <div
              class="avatar-inicitials"
              initials
              [name]="u.user.full_name"
            ></div>
          </div>
        </div>
        <div class="user-info">
          <div class="name">{{ u.user.full_name }}</div>
          <div class="email">{{ u.user.email }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="row">
    <div class="col-4 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-8">
      <button
        type="button"
        [disabled]="selectedUsers.length == 0"
        class="btn btn-primary"
        (click)="inviteUsers()"
      >
        <span>Add Users</span>
      </button>
    </div>
  </div>
</div>
